// Connector gating for the `wholesale` KPI table. Each retailer sell-through
// row belongs to one email ingestion connector; a company sees the table only
// when at least one of them is CONNECTED (first accepted upload), and only
// the rows of the retailers it has. `wholesale_total_revenue` is the rollup of
// every retailer row, so it shows whenever any retailer row does.

const WHOLESALE_TOTAL_METRIC = 'metrics.wholesale_total_revenue';

export const WHOLESALE_METRIC_SERVICES: Readonly<Record<string, string>> = {
  'metrics.wholesale_rei_regular_revenue': 'email_rei',
  'metrics.wholesale_sams_club_regular_revenue': 'email_sams_club',
  'metrics.wholesale_whole_foods_regular_revenue': 'email_whole_foods',
  'metrics.wholesale_walmart_regular_revenue': 'email_walmart',
  'metrics.wholesale_target_regular_revenue': 'email_target',
  'metrics.wholesale_spins_regular_revenue': 'email_spins',
  'metrics.wholesale_kroger_regular_revenue': 'email_kroger',
};

export const WHOLESALE_SERVICE_NAMES: readonly string[] = Object.values(WHOLESALE_METRIC_SERVICES);

export function filterWholesaleMetrics<T extends { key: string }>(metrics: readonly T[], connectedServices: readonly string[]): T[] {
  const connected = new Set(connectedServices);
  const retailerRows = metrics.filter((metric) => connected.has(WHOLESALE_METRIC_SERVICES[metric.key]));
  if (retailerRows.length === 0) return [];
  return metrics.filter((metric) => metric.key === WHOLESALE_TOTAL_METRIC || retailerRows.includes(metric));
}
